import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import CloseIcon from '@mui/icons-material/Close';
import LaunchIcon from '@mui/icons-material/Launch';

import CommonMessages from '~/core/commonMessages';
import { BettingOddPartner } from '~/core/types';

import { BettingOddsClose, BettingOddsLogoLink, NarrowOddsProviderContainer, OddsProviderLabel } from './styles';

type BettingOddsProps = {
    bettingOddPartner: BettingOddPartner;
    show: boolean;
    setShow: (a: boolean) => void;
};

const NarrowBettingOdds: FC<BettingOddsProps> = ({ bettingOddPartner, show, setShow }) =>
    // this check protects against the page crashing if there's no bettingOddPartner for a country
    bettingOddPartner &&
    show && (
        <NarrowOddsProviderContainer $partner={bettingOddPartner}>
            <OddsProviderLabel $partner={bettingOddPartner}>
                <FormattedMessage {...CommonMessages.gameInformationDescriptions.oddsBy} />
            </OddsProviderLabel>
            <BettingOddsLogoLink $partner={bettingOddPartner} href={bettingOddPartner.siteUrl} target="_blank">
                <img src={bettingOddPartner.imageUrl} alt={bettingOddPartner.name} />
                <LaunchIcon />
            </BettingOddsLogoLink>
            <BettingOddsClose $partner={bettingOddPartner}>
                <CloseIcon onClick={() => setShow(false)} />
            </BettingOddsClose>
        </NarrowOddsProviderContainer>
    );

export default NarrowBettingOdds;
